export const UPGRADE_PRICE_COEFFICIENT = 1.25;

// when a new airplane/airport/manager/lounge is bought, its base upgrade prices will be a little bit higher than the previous one
export const PRICE_STEP_COEFFICIENT = 1.5;

// this coefficient is applied to the ticket price multiplier when you advance
export const ADVANCE_COEFFICIENT = 1.5;
// this coefficient is used to calculate the number of passengers required to advance, a little bit higher than price
// multiplier coefficient so that you will need to transport a little more passengers to advance every time
export const ADVANCE_PASSENGERS_COEFFICIENT = 1.65;

export const BASE_AIRPORT_PRICE = 50000;
